import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    origins: { type: Array, default: [] },
    type: String
  }

  connect () {
    this.onMessage = this.onMessage.bind(this)
    window.addEventListener('message', this.onMessage)
  }

  disconnect () {
    window.removeEventListener('message', this.onMessage)
  }

  onMessage (event) {
    if (!this.originsValue.includes(event.origin)) return
    if (event.data?.type !== this.typeValue) return

    this.dispatch('received')
  }
}
